import { lazy } from "react";

export const CoursePage = lazy(() => import("./coursePage"));
